module.exports = __webpack_public_path__ + "img/1.13e7ab40.jpg";